import { authStore } from '../../../stores';
import { InitType, MinimumBootArgs, Regions } from '@intercom/messenger-js-sdk/dist/types';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const DISABLED_INTERCOM_ROUTES = ['/event/[eventAlias]', '/event/[eventAlias]/[shortInstance]'];

export const useIntercom = () => {
	const router = useRouter();

	const currentUser = authStore.user;
	const intercomAppId = process.env['NEXT_PUBLIC_INTERCOM_APP_ID'];

	useEffect(() => {
		if (DISABLED_INTERCOM_ROUTES.includes(router.pathname)) {
			if (window.Intercom) {
				shutdown();
			}

			return;
		}

		if (currentUser && intercomAppId) {
			const config: MinimumBootArgs | InitType = {
				region: process.env['NEXT_PUBLIC_INTERCOM_REGION'] as Regions,
				app_id: intercomAppId,
				name: currentUser.fullName,
				email: currentUser.email,
				user_id: currentUser.id,
			};

			if (currentUser.isCommunityProfile) {
				config.company = {
					id: currentUser.id,
					name: currentUser.fullName,
				};
			}

			if (!currentUser.isCommunityProfile && currentUser.subscribers.length) {
				const communitySubscriptions = currentUser.subscribers.filter(({ user }) => !user.isCommunityProfile);

				if (!communitySubscriptions.length) {
					return;
				}
				config.companies = communitySubscriptions.map(({ user }) => ({
					id: user.id,
					name: user.fullName,
				}));
			}

			Intercom(config);
			console.log('Intercom initialized successfully for authenticated user');
		}

		if (!currentUser && intercomAppId) {
			Intercom({
				region: process.env['NEXT_PUBLIC_INTERCOM_REGION'] as Regions,
				app_id: intercomAppId,
			});
			console.log('Intercom initialized successfully for unauthenticated user');
		}
	}, [currentUser, intercomAppId, router.pathname]);
};
